import { AppLanguage, getPreferredLanguage } from '../language';
import { dsIntroductionTemplate } from './dsDropshippingGuide/dsIntroduction';
import { dsAccountTemplate } from './dsDropshippingGuide/dsAccount';
import { dsWarehouseInfoTemplate } from './dsDropshippingGuide/dsWarehouseInfo';
import { dsPrepareTemplate } from './dsDropshippingGuide/dsPrepare';
import { dsShippingTemplate } from './dsDropshippingGuide/dsShipping';
import { dsOperationsTemplate } from './dsDropshippingGuide/dsOperations';
import { dsIntegrationTemplate } from './dsDropshippingGuide/dsIntegration';
import { dsLandingTemplate } from './dsDropshippingGuide/dsLanding';
import { dsSupportTemplate } from './dsDropshippingGuide/dsSupport';
import type { DsDropshippingGuideI18nTemplate } from './dsDropshippingGuide/dsTypes';

export type DropshippingGuideI18nTemplate = DsDropshippingGuideI18nTemplate;

export const TEMPLATES: Record<AppLanguage, DropshippingGuideI18nTemplate> = {
  zh: {
    landing: dsLandingTemplate.zh,
    introduction: dsIntroductionTemplate.zh,
    account: dsAccountTemplate.zh,
    warehouseInfo: dsWarehouseInfoTemplate.zh,
    prepare: dsPrepareTemplate.zh,
    shipping: dsShippingTemplate.zh,
    operations: dsOperationsTemplate.zh,
    integration: dsIntegrationTemplate.zh,
    support: dsSupportTemplate.zh,
  },
  en: {
    landing: dsLandingTemplate.en,
    introduction: dsIntroductionTemplate.en,
    account: dsAccountTemplate.en,
    warehouseInfo: dsWarehouseInfoTemplate.en,
    prepare: dsPrepareTemplate.en,
    shipping: dsShippingTemplate.en,
    operations: dsOperationsTemplate.en,
    integration: dsIntegrationTemplate.en,
    support: dsSupportTemplate.en,
  },
};

export const DROPSHIPPING_GUIDE_NAMESPACE = 'dropshippingGuide';

export const DROPSHIPPING_GUIDE_RESOURCE_KEY = 'template';

export const DROPSHIPPING_GUIDE_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof DROPSHIPPING_GUIDE_RESOURCE_KEY, DropshippingGuideI18nTemplate>
> = {
  zh: {
    [DROPSHIPPING_GUIDE_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [DROPSHIPPING_GUIDE_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getDropshippingGuideTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): DropshippingGuideI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
